import { BriefcaseBusiness, Inbox, LayoutDashboard, Settings } from "lucide-react";

export type View = "pending" | "applications" | "responses" | "settings";

const items = [
  { id: "pending" as const, label: "Pendientes", icon: LayoutDashboard },
  { id: "applications" as const, label: "Aplicadas", icon: BriefcaseBusiness },
  { id: "responses" as const, label: "Respuestas", icon: Inbox },
  { id: "settings" as const, label: "Configuración", icon: Settings },
];

export function Sidebar({ view, onChange }: { view: View; onChange: (view: View) => void }) {
  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand-mark">JP</div>
        <div><strong>JobPilot</strong><span>Tu CRM laboral</span></div>
      </div>
      <nav>
        {items.map(({ id, label, icon: Icon }) => (
          <button className={view === id ? "nav-item active" : "nav-item"} key={id} onClick={() => onChange(id)}>
            <Icon size={19} /> {label}
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <span className="status-dot" /> Automatización activa
        <small>Próxima revisión: 06:30</small>
      </div>
    </aside>
  );
}
